<template>
    <div class="load-unload-delegate-attachment-table">
        <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="fileName" label="附件名称" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="fileId" label="附件预览" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handlePreview(scope.row)">预览</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="uploadTime" label="上传时间" align="center"></el-table-column>
            <el-table-column fixed="right" label="操作" width="120" align="center" v-if="!isApprove">
                <template slot-scope="scope">
                    <Upload
                        uploadDisplayType="text"
                        text="重新上传"
                        :fileTypeReg="/\.(jpg|jpeg|png|pdf)$/"
                        :disabled="isSupplier || isPendingOrAdopt"
                        @uploadSuccess="handleUploadSuccess($event, scope.$index)"
                    />
                    <el-button type="text" size="small" :disabled="isSupplier || isPendingOrAdopt" @click="handleDel(scope.$index)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import Upload from '../../../components/upload/Index.vue';

export default {
    components: { Upload },
    props: {
        tableData: {
            type: Array,
            default: () => {
                return []
            }
        },
        isApprove: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        isPendingOrAdopt: {
            type: Boolean,
            default: () => {
                return false
            }
        },
    },
    data() {
        return {};
    },
    computed: {
        isSupplier() {
            return !!this.$store.state.supplier
        },
    },
    // created() {
    //     this.tableData = this.fileDataList;
    // },
    methods: {
        handleClose() {
            this.$emit('handleClose', '')
        },
        handlePreview(row) {
            this.$emit('preview', row.fileUrl)
        },
        //  fileUrl 图片路径
        handleUploadSuccess (result, index) {
            this.$emit('reupload', result, index)
        },
        handleDel(index) {
            this.$confirm('您确定要删除该附件吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$emit('delete', index)
            }).catch(() => { })
        }
    }
}
</script>
<style lang="less">
.load-unload-delegate-attachment-table {
    margin-bottom: 10px;

    .register-upload {
        font-size: 12px;
        line-height: 1;
        vertical-align: middle;
        color: #00bcbf;
    }

    .el-button {
        padding: 0;
    }
}
</style>
